<template>
  <DoubleNumberFrame
      title="Places Viewed"
      :primary-value="$numberManagement.contractInteger(itemData.value1)"
      :secondary-value="$numberManagement.contractInteger(itemData.value2)"
      :changes-style="itemData.changes.style"
      :changes-value="itemData.changes.value"
  >
    <template v-slot:icon>
      <icon/>
    </template>
  </DoubleNumberFrame>
</template>

<script>

import icon from '../../../../../public/img/cil-location-pin.svg';
import DoubleNumberFrame from './DoubleNumberFrame.vue';

export default {
  name: 'DoubleNumberFramePlacesViewed',
  components: {
    icon,
    DoubleNumberFrame,
  },

  props: {
    itemData: {
      type: Object,
      default() {
        return ({});
      },
    },
  },
};
</script>
